/**
 * Single source of truth for what counts as a queryable cage id.
 *
 * It has to be a positive safe integer. Consumers use it to gate React Query `enabled` flags and
 * the derived loading booleans, so both sides of the boundary stay in agreement — avoid ad hoc
 * `cageId > 0` / `!!cageId` / `cageId === 0`, they drift.
 *
 * It lives in the data layer rather than in `contexts/cage` because it is a data-layer invariant:
 * `CageProvider` is one of its consumers, and domain hooks must be able to gate themselves without
 * importing from a context.
 */
export function isValidCageId(cageId: number): boolean {
    return Number.isSafeInteger(cageId) && cageId > 0;
}
